'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialRss = function IoSocialRss(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm9.4 26.3c2.4 0 4.4 1.9 4.4 4.3s-2 4.4-4.4 4.4-4.4-2-4.4-4.4 2-4.3 4.4-4.3z m-4.4-11.3c10.9 0 20 9.1 20 20h-6.2c0-3.7-1.1-7.3-3.8-10s-6.2-3.7-10-3.7v-6.3z m0-10c16.6 0 30 13.4 30 30h-6.2c0-13.4-10.4-23.7-23.8-23.7v-6.3z' })
        )
    );
};

exports.default = IoSocialRss;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-rss.js
// module id = 2467
// module chunks = 0